export const SUBSCRIPTIONS_PROGRAM_ID = "SsubM7pGA83VRnCodXVrxU2GZNBQzBYgzPUYBssCwU1";
export const PRODUCT_SEED = "product";
export const PURCHASE_SEED = "purchase";
export const GLOBAL_STATE_SEED = "global_state";
